import * as apiEvents from './';

export class WebHubEventCaller {

	private constructor() {
		Object.defineProperty(this.Receive_Scheduler_Changed, 'name', { value: 'Receive_Scheduler_Changed', writable: false });
		Object.defineProperty(this.Notify_Scheduler_Changed, 'name', { value: 'Notify_Scheduler_Changed', writable: false });
		Object.defineProperty(this.Notify_OrderStatus_Changed, 'name', { value: 'Notify_OrderStatus_Changed', writable: false });
	}

	static readonly instance = new WebHubEventCaller();

	Receive_Scheduler_Changed(model: apiEvents.ApiAppointmentChangedEvent) { }
	Notify_Scheduler_Changed(model: apiEvents.AppointmentChangedEvent) { }
	Notify_OrderStatus_Changed(model: apiEvents.OrderStatusChangedEvent) { }
}
